import ApiService from "../../../../../services/ApiService";
import translate from "../../../../../services/Translate";

export const updateExerciseResources = (
  exerciseId: number,
  data: any,
  setIsEditing: Function,
  onSuccess: Function,
  language: string
) => {
  setIsEditing(true);
  ApiService.patch(`exercises/${exerciseId}`, {
    required_cpu: data.cpu || null,
    required_memory: data.memory || null,
    required_ephemeral_storage: data.ephemeral_storage || null,
  })
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Error updating exercise resources:", error);
      alert(translate(language, "PAGES.EXERCISE.MAIN_INFOS_TAB.ERROR.UPDATE_EXERCISE_RESOURCE"));
    })
    .finally(() => setIsEditing(false));
};
